/* template */
import BookTemplate from "../components/template/BookTemplate"

const Book = () => {
    return < BookTemplate />
}

export default Book